<template>
    <v-flex xs12 pb-3>
        <v-expansion-panel>
            <v-expansion-panel-content v-for="(parecer, index) in pareceresOrdenados" :key="index">
                <div slot="header">
                    <v-layout row wrap>
                        <v-flex xs12 sm4>
                            <b>Data:</b> {{ toLocaleDateTimeString(parecer.dataCriacao) }}
                        </v-flex>
                        <v-flex v-if="permissaoAnalisaSolicitacao" xs12 sm4>
                            <b>Status:</b> {{ parecer.status.descricao }}
                        </v-flex>
                        <v-flex v-else xs12 sm4>
                            <b>Status:</b> {{ parecer.status.statuscliente }}
                        </v-flex>
                        <v-flex xs12 sm4>
                            <b>Usuário:</b> {{ parecer.nomeUsuarioAutor }}
                        </v-flex>
                    </v-layout>
                </div>
                <v-card>
                    <v-card-text class="themeGrey--text">{{parecer.descricao}}</v-card-text>
                </v-card>
            </v-expansion-panel-content>
        </v-expansion-panel>
        <br v-if="model.pareceres && model.pareceres.length > 0" />
        <v-card v-if="permissaoAnalisaSolicitacao">
            <v-card-text>
                <v-container grid-list-lg>
                    <v-form ref="formParecer" v-model="formValidParecer">
                        <v-layout row wrap>
                            <v-flex xs12 sm6 md4>
                                <v-select-status :itens="getStatusList" :rules="regras.status" :status="parecerModel.status" v-model="parecerModel.status"></v-select-status>
                            </v-flex>
                            <v-flex xs12>
                                <v-textarea :rules="regras.descricao" v-model="parecerModel.descricao" label="Parecer técnico"></v-textarea>
                            </v-flex>
                            <v-flex xs12>
                                <v-btn :disabled="!formValidParecer || parecerModel.descricao.length <= 0"
                                @click.native="insereParecer(undefined, undefined)"
                                :block="$vuetify.breakpoint.xsOnly" 
                                class="white--text right"
                                :loading="loadingSalvar"
                                color="primary">
                                    Salvar
                                    <v-icon right class="hidden-sm-and-down">save</v-icon>
                                </v-btn>
                            </v-flex>
                        </v-layout>
                    </v-form>
                </v-container>
            </v-card-text>
        </v-card>
        <v-snackbar
            :timeout="6000"
            :color="snackbarParecer.sucesso ? 'success' : 'error'"
            multi-line
            v-model="snackbarParecer.visivel">
            {{ snackbarParecer.mensagem }}
            <v-btn dark flat @click.native="snackbarParecer.visivel = false">Fechar</v-btn>
        </v-snackbar>
    </v-flex>
</template>

<script>
import VSelectStatus from '@/components/shared/VSelectStatus'
import CustomFormat from '@/helpers/custom-format'
import perfil from '@/helpers/perfil'
import usuarioHelper from '@/helpers/usuario-logado';
import axios from 'axios'
import cipher from '@/helpers/cipher'
import EStatus from '@/helpers/estatus'
import permissoes from '@/helpers/permissoes.js'

export default {
    name: 'parecer',
    props: ["model"],
    components: {
        VSelectStatus
    },
    data: () => {
        return {
            formValidParecer: false,
            loadingSalvar: false,
            lstStatus: null,
            snackbarParecer: {
                visivel: false,
                sucesso: true,
                mensagem: ''
            },
            parecerModel: {
                idQuestionario: '',
                status: [{}],
                descricao: '',
                nomeUsuarioAutor: ''
            },
            regras: {
                status: [
                    v => !!v || 'Você não pode deixar este campo em branco'
                ],
                descricao: [
                    v => !!v && v.length > 0
                ]
            }
        }
    },
    computed: {
        permissaoAnalisaSolicitacao: function() {
          return permissoes.verificaPermissao(permissoes.SolicitacaoConsulta.ANALISA_SOLICITACAO)
        },
        pareceresOrdenados: function () {
            return this.model.pareceres.sort((a, b) => { return b.dataCriacao.localeCompare(a.dataCriacao); });
        },
        getStatusList: function () {
            if (this.lstStatus != null && this.parecerModel.status != undefined) {
              return this.lstStatus;
            }
        }
    },
    watch: {
      'model.status.id': function (value) {
        this.carregaStatusList();
      }
    },
    mounted: async function () {
        await this.carregaStatusList();
        await this.insereParecerAutomatico();
    },
    methods: {
        toLocaleDateTimeString: function (value) {
            return CustomFormat.toLocaleDateTimeString(value);
        },
        insereParecer: async function (parecerParam, snackbarParam) {
            const self = this;
            if (parecerParam != undefined) {
                self.parecerModel = parecerParam;
            } else {
                self.parecerModel.idQuestionario = self.model.id;
                self.parecerModel.status = self.parecerModel.status[0];
                self.parecerModel.descricao = self.parecerModel.descricao;
                self.parecerModel.nomeUsuarioAutor = usuarioHelper.USUARIO_LOGADO().nome;
            }

            const statusSelecionado = self.parecerModel.status;

            if (snackbarParam != undefined) {
                self.snackbarParecer.mensagem = snackbarParam.mensagem;
            } else {
                self.snackbarParecer.mensagem = 'Parecer incluído com sucesso.';
            }

            self.$store.commit('startLoading');
            self.loadingSalvar = true;
            await axios.post(`${process.env.URL_QUESTIONARIOMS}/v1/insereParecer`, self.parecerModel, {
                headers: {
                    'Authorization': `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
                }
            }).then((response) => {
                self.snackbarParecer.visivel = true;
                self.snackbarParecer.sucesso = true;

                self.resetParecerModel();
                self.$parent.carregaQuestionario();
                self.parecerModel.status = [ statusSelecionado ];
                self.atualizaStatusList();
            }).catch((err) => {
                self.snackbarParecer.mensagem = 'Algo de inesperado aconteceu.'
                self.snackbarParecer.sucesso = false;
                self.snackbarParecer.visivel = true;
            }).then(() => {
                self.$store.commit('endLoading');
                self.loadingSalvar = false;
            });
        },
        insereParecerAutomatico: async function () {
            const self = this;
            if (self.permissaoAnalisaSolicitacao) {
                switch (self.model.status.id) {
                    case EStatus.statusEnum.PENDENTE:
                        var statusParam;
                        for (var index in self.lstStatus) {
                            if (self.lstStatus[index][0].id == 2) {
                                statusParam = self.lstStatus[index][0];
                                break;
                            }
                        }
                        var parecerParam = {
                            idQuestionario: self.model.id,
                            status: statusParam,
                            descricao: 'A proposta está em análise.',
                            nomeUsuarioAutor: usuarioHelper.USUARIO_LOGADO().nome
                        }
                        var snackbarParam = {
                            mensagem: 'O status foi alterado para "Em Análise".'
                        }
                        self.insereParecer(parecerParam, snackbarParam);
                        break;            
                    default:
                        break;
                }
            }
        },
        carregaStatusList: async function () {
            const self = this;
            await axios.get(`${process.env.URL_QUESTIONARIOMS}/v1/buscaTodosStatusQuestionario`, {
                headers: {
                    'Authorization': `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
                }
            }).then(response => {
                self.lstStatus = response.data.filter((status) => {
                  if (status.id == self.model.status.id) {
                    self.parecerModel.status = [ status ];
                  }
                  return  status.ordem >= self.model.status.ordem &&
                          (status.id != EStatus.statusEnum.ENCERRADO &&
                          (status.id != EStatus.statusEnum.EM_ANALISE &&
                           self.parecerModel.status.id != EStatus.statusEnum.PENDENTE) &&
                           status.id != self.model.status.id ?
                           status.automatico == false : true);
                })
                .sort((a, b) => {
                    return a.ordem - b.ordem;
                });
                self.processaStatusList();
            });
        },
        processaStatusList: function () {
            const self = this;
            if (self.permissaoAnalisaSolicitacao) {
                for (var i = 0; i < self.lstStatus.length; i++) {
                  self.lstStatus[i] = [ self.lstStatus[i] ];
                }
            } else {
                var statusClienteRepetido = [];
                for (var i = 0; i < self.lstStatus.length; i++) {
                    for (var j = i+1; j < self.lstStatus.length; j++) {
                        if (self.lstStatus[i].statuscliente == self.lstStatus[j].statuscliente) {
                            statusClienteRepetido.push(self.lstStatus[j]);
                            self.lstStatus.splice(j, 1);
                            j -= 1;
                        }
                    }
                }
                for (var i = 0; i < self.lstStatus.length; i++) {
                    self.lstStatus[i] = [ self.lstStatus[i] ];
                    for (var j = 0; j < statusClienteRepetido.length; j++) {
                        if (self.lstStatus[i][0].statuscliente == statusClienteRepetido[j].statuscliente) {
                            self.lstStatus[i].push(statusClienteRepetido[j]);
                        }
                    }
                }
            }
        },
        atualizaStatusList: function () { //Remove os status anteriores ao da solicitação.
            const self = this;
            var statusClienteRepetido = [];
            self.lstStatus = self.lstStatus.filter((status) => {
                return status[0].ordem >= self.parecerModel.status[0].ordem;
            })
            .sort(function(a, b){
                return a[0].ordem - b[0].ordem;
            });
        },
        resetParecerModel: function() {
          this.parecerModel = {
            idQuestionario: '',
            status: [{}],
            descricao: '',
            nomeUsuarioAutor: ''
          }
        }
    }
}
</script>




// WEBPACK FOOTER //
// src/components/pages/solicitacao-consulta/Parecer.vue